export enum TeamInviteStatus {
    Pending = 0,
    Accepted = 1,
    Declined = 2
}